import React, { useState, createContext } from 'react';
import { Modal } from '@one-thd/sui-atomic-components';
const ModalContext = createContext(null);
const ModalProvider = ({ children }) => {
    const initialState = {
        ContentComponent: null,
        componentProps: {},
        modalProps: {},
        isOpened: false,
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [modalState, setModalState] = useState(initialState);
    /**
     * openModal function.
     *
     * @param {React.FC} ContentComponent - a modal content component
     * @param {any} [componentProps={}] - a modal content component (ContentComponent) props
     * @param {IModalProps} [modalProps={}] - a stencil modal props
     *
     * @example
     *     const BasicModalContent = ({title}: string) => <p>This is a basic modal's content. {title}</p>;
     *     // Update  stencil modal props
     *     const modalProps = { size: 'sm' };
     *
     *     openModal(BasicModalContent, { title: 'Modal Title' }, modalProps);
     */
    const openModal = (ContentComponent, componentProps, modalProps = {}) => {
        setModalState({
            ContentComponent,
            componentProps,
            modalProps,
            isOpened: true,
        });
    };
    /**
     * hideModal function for hiding (closing) opened modal
     *
     */
    const hideModal = () => {
        setModalState({
            ContentComponent: null,
            componentProps: {},
            modalProps: {},
            isOpened: false,
        });
    };
    const setComponentProps = (componentProps) => {
        setModalState((prevModalState) => (Object.assign(Object.assign({}, prevModalState), { componentProps: Object.assign(Object.assign({}, prevModalState.componentProps), componentProps) })));
    };
    return (React.createElement(ModalContext.Provider, { value: {
            openModal,
            hideModal,
            isOpened: modalState.isOpened,
            setComponentProps,
        } },
        React.createElement(Modal, Object.assign({ open: modalState.isOpened, onClose: hideModal }, modalState.modalProps), modalState.ContentComponent && (React.createElement(modalState.ContentComponent, Object.assign({ hideModal: hideModal }, modalState.componentProps)))),
        children));
};
export { ModalProvider, ModalContext };
